import { render, staticRenderFns } from "./ValidacionPorRespuesta.vue?vue&type=template&id=63c6f682&lang=true"
import script from "./ValidacionPorRespuesta.vue?vue&type=script&lang=js"
export * from "./ValidacionPorRespuesta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports